export default {
  initialise(state) {
    if (localStorage.getItem('store') && state.useCache) {
      const store = JSON.parse(localStorage.getItem('store'));
      const { user, lastRead } = store;
      this.replaceState(
        Object.assign(state, { user, lastRead }),
      );
    }
  },
  set(state, { model, value }) {
    state[model] = value;
  },
  saveStrip(state, strip) {
    if (strip && (strip.number !== undefined)) {
      const strips = state.strips || [];
      const getIndex = strips.findIndex((savedStrip) => {
        const stripNumber = parseInt(strip.number, 10);
        const savedStripNumber = savedStrip && parseInt(savedStrip.number, 10);
        return stripNumber === savedStripNumber;
      });
      if (getIndex > -1) {
        strips[getIndex] = strip;
      } else {
        strips.push(strip);
      }
      state.strips = strips;
    }
  },
  removeStrip(state, stripNumber) {
    if (stripNumber && state.strips) {
      const stripIndex = state.strips.findIndex(strip => (
        strip && (strip.number === stripNumber)
      ));
      delete state.strips[stripIndex];
    }
  },
};
